import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Icon, Confirm } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { Cont } from './styled'
import { StdForm } from 'components'
import { fetchProjectUsers, deleteProjectUser } from 'ducks/roleMan'
import { columns } from '../../AttributeData'

import { btnGray } from 'variables/styles'

import FormProjectUser from './FormProjectUser'

let refTable = React.createRef()

const ProjectUser = props => {
  const {
    projectUsers,
    showModal,
    setShowModal,
    modalData,
    setModalData,
    modalTitle,
    setModalTitle,
    modalIsCreate,
    setModalIsCreate,
    showConfirm,
    setShowConfirm,
    deleteId,
    setDeleteId,
    defaultPage,
    setDefaultPage,
  } = props
  const defaultExpanded = props.projectUsers.map((item, i) => {
    return false
  })
  return (
    <Cont>
      <StdForm
        fitContent={false}
        title={
          <div>
            Project User List
            <Icon
              link
              circular
              inverted
              color="teal"
              name="add"
              size="small"
              style={{ marginLeft: '1rem' }}
              onClick={() => showProjectUserModal(true, null)}
            />
          </div>
        }
        style={{ width: '80vw' }}
        enableCollapse
      >
        <ReactTable
          ref={r => (refTable = r)}
          data={projectUsers && projectUsers}
          defaultExpanded={{ defaultExpanded }}
          collapseOnDataChange={false}
          columns={columns.tProjectUser}
          defaultPageSize={10}
          previousText="previous"
          nextText="next"
          className="-striped -highlight"
          onPageChange={state => {
            props.setDefaultPage(state)
          }}
          page={defaultPage}
          SubComponent={row => {
            return (
              <div style={{ padding: '1rem', width: '70vw' }}>
                <ReactTable
                  data={row.original.users}
                  columns={columns.tProjectUserList}
                  defaultPageSize={5}
                  getTdProps={(state, rowInfo, column, instance) => {
                    if (!column.Header) {
                      return {
                        onClick: (e, handleOriginal) => {
                          props.setDeleteId(null)
                          if (e.target.nodeName === 'I') {
                            props.setDeleteId(rowInfo.original.id)
                            setShowConfirm(true)
                          }
                        },
                      }
                    } else {
                      return {}
                    }
                  }}
                />
              </div>
            )
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (!column.Header) {
                  state.expanded[rowInfo.index] = !state.expanded[rowInfo.index]
                }
                if (handleOriginal) {
                  handleOriginal()
                }
              },
              style: {
                background: rowInfo
                  ? state.expanded[rowInfo.index]
                    ? btnGray
                    : 'initial'
                  : null,
                color: rowInfo
                  ? state.expanded[rowInfo.index]
                    ? '#fff'
                    : 'initial'
                  : null,
              },
            }
          }}
        />
      </StdForm>
      {showModal.projectUser ? (
        <FormProjectUser
          title={modalTitle}
          data={modalData}
          isCreate={modalIsCreate}
          show={showModal.projectUser}
          tablePageSize={refTable ? refTable.state.pageSize : 5}
          setCurrentPage={props.setDefaultPage}
          changeShow={() =>
            setShowModal({ ...showModal, projectUser: !showModal.projectUser })
          }
        />
      ) : null}
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => onDeleteProjectUserClick()}
      />
    </Cont>
  )

  function showProjectUserModal(isCreate, data) {
    if (isCreate) {
      setModalIsCreate(true)
      setModalTitle('Create Project User')
      setModalData(null)
    } else {
      setModalIsCreate(false)
      setModalTitle('Update Project User')
      setModalData(data)
    }
    setShowModal({ ...showModal, projectUser: true })
  }
  function onDeleteProjectUserClick() {
    props.deleteProjectUser(props.deleteId)
    setShowConfirm(false)
  }
}

const mapStateToProps = state => ({
  projectUsers: state.roleMan.projectUsers,
})

const mapDispatchToProps = {
  fetchProjectUsers,
  deleteProjectUser,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showModal', 'setShowModal', {
    userRole: false,
    projectUser: false,
  }),
  withState('modalIsCreate', 'setModalIsCreate', false),
  withState('modalData', 'setModalData', null),
  withState('modalTitle', 'setModalTitle', ''),
  withState('userId', 'setUserId', 0),
  withState('showConfirm', 'setShowConfirm', false),
  withState('deleteId', 'setDeleteId'),
  withState('defaultPage', 'setDefaultPage', 0),
  lifecycle({
    componentDidMount() {
      this.props.fetchProjectUsers()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(ProjectUser)
